/**
 * @file AgencyMultiSelect.js
 * @description A multi-select dropdown component for selecting agencies.
 */

import React, { useState, useEffect } from 'react';
import { SearchableDropdown } from '../../helpers/SearchableDropdown_style_b_v2';
import { fetchAgencies } from '../../../services/systemService';
import Toast from '../../ui/toasts/Toast';
import { getText } from '../../../i18n';

const AgencyMultiSelect = ({
    className = '',
    selectedAgencies,
    onAgenciesChange,
    label = 'Assigned Agencies',
    isRequired = false,
    disabled = false,
    resetTrigger,
    showSelectedItemsInField = true,
    showSelectionBox = false,
    showSelectedCount = false,
    showTruncatedNames = true,
    maxLabelCharacters = 30,
}) => {
    const [agencies, setAgencies] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const loadAgencies = async () => {
            try {
                setIsLoading(true);
                const data = await fetchAgencies();
                setAgencies(data.viewModels ?? []);
            } catch (error) {
                console.error('Could not fetch agencies:', error);
                Toast.error(getText('msg_6c3d1945a7f9'));
            } finally {
                setIsLoading(false);
            }
        };

        loadAgencies();
    }, []);

    const handleAgenciesChange = selectedOptions => {
        onAgenciesChange(selectedOptions);
    };

    return (
        <div className={`form-group mb-3 ${className}`}>
            <label htmlFor="agency-multi-select">
                {selectedAgencies.length <= 1 ? 'Assigned Agency' : label}
                {isRequired && <span className="text-danger"> *</span>}
            </label>
            <SearchableDropdown
                id="agency-multi-select"
                options={agencies}
                optionIDField="id"
                updateOptions={handleAgenciesChange}
                savedOptions={selectedAgencies}
                savedOptionIDField="id"
                disabled={disabled || agencies.length === 0}
                isLoading={isLoading}
                resetTrigger={resetTrigger}
                showSelectedItemsInField={showSelectedItemsInField}
                showSelectionBox={showSelectionBox}
                showSelectedCount={showSelectedCount}
                showTruncatedNames={showTruncatedNames}
                maxLabelCharacters={maxLabelCharacters}
                allSelectedLabel={getText('msg_70c7e69a5f14')}
                placeholder={getText('msg_8598222918d3')}
            />
        </div>
    );
};

export default AgencyMultiSelect;
